import { PageMap } from '@wix/wixstores-client-core';
import { BaseActions } from './baseActions';

export interface CatalogReference {
  catalogItemId: string;
  appId: string;
  options?: Record<string, unknown>;
}

export class SuccessPopupActions extends BaseActions {
  public async showSuccessPopup(
    catalogReference: CatalogReference,
  ): Promise<void> {
    if (this.siteStore.isMobile()) {
      throw new Error("Can't open success popup on mobile");
    }
    const lightbox = await this.getSuccessPopupLightbox();
    if (!lightbox) {
      throw new Error('Success popup lightbox not found');
    }

    this.openSuccessPopup(lightbox.id!, catalogReference);
  }

  public async hasSuccessPopup(): Promise<boolean> {
    const lightbox = await this.getSuccessPopupLightbox();
    return !!lightbox;
  }

  private openSuccessPopup(
    id: string,
    catalogReference: CatalogReference,
  ): void {
    if (this.siteStore.siteApis.currentPage?.type === 'lightbox') {
      this.siteStore.windowApis.lightbox.close();
    }
    void this.siteStore.windowApis.openLightboxById(id, { catalogReference });
  }

  private async getSuccessPopupLightbox() {
    const siteStructure = await this.siteStore.wixCodeApi.site.getSiteStructure(
      { includePageId: true },
    );
    return siteStructure.lightboxes?.find(
      (lightbox) => lightbox.tpaPageId === PageMap.SUCCESS_POPUP,
    );
  }
}
